import config from '../config/config';
let util = {};

// 成功
util.success = function (val) {
    if (val === undefined || val === '' || val === null) {
        val = '成功！';
    }
    layui.use('layer', function () {
        layer.msg(val, {
            icon: 1,
            offset: config.layer.msg.top,
            time: config.layer.msg_timeout
        });
    });
};
// 成功
util.success2 = function (val) {
	if (val === undefined || val === '' || val === null) {
		val = '成功！';
	}
	layui.use('layer', function () {
		layer.msg(val, {
			icon: 1,
			offset: config.layer.msg.top,
			// area:["500px","200px"],
			time: false,
			btn: ['关闭']
		});
	});
};

// 失败
util.error = function (val) {
    if (val === undefined || val === '' || val === null) {
        val = '失败！';
    }
    layui.use('layer', function () {
        layer.msg(val, {
            icon: 2,
            offset: config.layer.msg.top,
            time: config.layer.msg_timeout
        });
    });
};

// 失败
util.error2 = function (val) {
	if (val === undefined || val === '' || val === null) {
		val = '失败！';
	}
	layui.use('layer', function () {
		layer.msg(val, {
			icon: 2,
			offset: config.layer.msg.top,
			// area:["500px","220px"],
			time: false,
			btn: '关闭',
	});
	});
};

// 警告
util.warning = function (val) {
	if (val === undefined || val === '' || val === null) {
		val = '警告！';
	}
	layui.use('layer', function () {
		layer.msg(val, {
			icon: 0,
			offset: config.layer.msg.top,
			time: false,
			btn: ['关闭'],
		});
	});
};

// 判断空
util.isEmpty = function (obj) {
    if (obj === undefined || obj === '' || obj === null || obj === {}) {
        return true;
    }
    return false;
};


// 计算日期属于当月第几周的周几
util.getIndexWeek = function(obj){
    var d = new Date(obj);

    var start = d.getFullYear() +'-'+ d.getMonth() +"-01 01:00:00";
    var s = new Date(start);

    var day = d.getDay();
    var dDate = d.getDate();

    var startDay = s.getDay();
    var sDate = s.getDate();

    var num = parseInt((dDate - sDate) / 7)+1;

    var weeks = ['星期日','星期一','星期二','星期三','星期四','星期五','星期六'];

    var resWeek = weeks[day];

    return  '第'+ num + '个' + resWeek;
};


//UUID
util.guid = function (){
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
        return v.toString(16);
    });
}

// 登出
util.logOut = function(vm){
    vm.$router.push({
        name: 'login',
    })
}

// 时间格式化
util.toDate = function (date) {
    if (util.isEmpty(date)) {
        return '';
    }
    let unix = Date.parse(new Date(date));
    let unixTimestamp = new Date(unix)
    let Y = unixTimestamp.getFullYear()
    let M = ((unixTimestamp.getMonth() + 1) >=   10 ? (unixTimestamp.getMonth() + 1) : '0' + (unixTimestamp.getMonth() + 1))
    let D = (unixTimestamp.getDate() >= 10 ? unixTimestamp.getDate() : '0' + unixTimestamp.getDate())
    let H = unixTimestamp.getHours()
    H = H < 10 ? ('0' + H) : H
    let i = unixTimestamp.getMinutes()
    i = i < 10 ? ('0' + i) : i
    let s = unixTimestamp.getSeconds()
    s = s < 10 ? ('0' + s) : s
    // let dateRes = Y + '-' + M + '-' + D + ' ' + H + ':' + i + ':' + s;
    let dateRes = Y + '-' + M + '-' + D ;
    return dateRes;
};

// 获取当月1号
util.tothisMonth = function (date) {
	if (util.isEmpty(date)) {
		return '';
	}
	let unix = Date.parse(new Date(date));
	let unixTimestamp = new Date(unix)
	let Y = unixTimestamp.getFullYear()
	let M = ((unixTimestamp.getMonth() + 1) >=   10 ? (unixTimestamp.getMonth() + 1) : '0' + (unixTimestamp.getMonth() + 1))
	let D = '01'
	let dateRes = Y + '-' + M + '-' + D ;
	return dateRes;
};

// 获取下月1号
util.toNextMonth = function (date) {
	if (util.isEmpty(date)) {
		return '';
	}
	let unix = Date.parse(new Date(date));
	let unixTimestamp = new Date(unix)
	let Y = unixTimestamp.getFullYear()
	let nextMonth=unixTimestamp.getMonth() + 2;
	if (nextMonth>12){
		nextMonth=nextMonth-12;
		Y = Y+1;
	}
	let M = (nextMonth >=   10 ? nextMonth : '0' + nextMonth)
	let D = '01'
	let dateRes = Y + '-' + M + '-' + D ;
	return dateRes;
};

// 时间格式化
util.getNow = function (format) {
	// let unixTimestamp = new Date()
	// let Y = unixTimestamp.getFullYear()
	// let M = ((unixTimestamp.getMonth() + 1) >=   10 ? (unixTimestamp.getMonth() + 1) : '0' + (unixTimestamp.getMonth() + 1))
	// let D = (unixTimestamp.getDate() >= 10 ? unixTimestamp.getDate() : '0' + unixTimestamp.getDate())
	// let H = unixTimestamp.getHours()
	// H = H < 10 ? ('0' + H) : H
	// let i = unixTimestamp.getMinutes()
	// i = i < 10 ? ('0' + i) : i
	// let s = unixTimestamp.getSeconds()
	// s = s < 10 ? ('0' + s) : s
	// let dateRes;
	// if (util.isEmpty(format)){
	//     // let dateRes = Y + '-' + M + '-' + D + ' ' + H + ':' + i + ':' + s;
	//     dateRes =  Y + '-' + M + '-' + D + ' ' + H + ':' + i + ':' + s;
	// } else {
	//     dateRes =  Y + M + D + H + i + s;
	// }
	// return dateRes;
	let ret;
	let date = new Date()
	const opt = {
		"y+": date.getFullYear().toString(),        // 年
		"M+": (date.getMonth() + 1).toString(),     // 月
		"d+": date.getDate().toString(),            // 日
		"H+": date.getHours().toString(),           // 时
		"m+": date.getMinutes().toString(),         // 分
		"s+": date.getSeconds().toString()          // 秒
		// 有其他格式化字符需求可以继续添加，必须转化成字符串
	};
	for (let k in opt) {
		ret = new RegExp("(" + k + ")").exec(format);
		if (ret) {
			format = format.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
		};
	};
	return format;
};


// 排序参数
util.compare = function (property) {
    return function (a, b) {
        var value1 = a[property];
        var value2 = b[property];
        return value1 - value2;
    };
};

util.getFile = function(file){
    if(file!==undefined){
        var unix = new Date().getTime();
        var oldFileName = file.name;
        //重命名
        var type =oldFileName.substring(oldFileName.lastIndexOf('.'));
        var newFileName = unix + type;
        var newfile =  new File([file], newFileName,{type:file.type});
        return newfile;

    }
}

util.toCrrTimeStamp = function (date) {
    let unix = Date.parse(new Date(date));
    let unixTimestamp = new Date(unix)
    let Y = unixTimestamp.getFullYear()
    let M = ((unixTimestamp.getMonth() + 1) >= 10 ? (unixTimestamp.getMonth() + 1) : '0' + (unixTimestamp.getMonth() + 1))
    let D = (unixTimestamp.getDate() >= 10 ? unixTimestamp.getDate() : '0' + unixTimestamp.getDate())
    let H = unixTimestamp.getHours()
    H = H < 10 ? ('0' + H) : H
    let i = unixTimestamp.getMinutes()
    i = i < 10 ? ('0' + i) : i
    let s = unixTimestamp.getSeconds()
    s = s < 10 ? ('0' + s) : s
    let dateRes = Y + '-' + M + '-' + D + ' ' + H + ':' + i + ':' + s;
    return dateRes;
};

util.getToday = function () {
    let unixTimestamp = new Date();
    let Y = unixTimestamp.getFullYear()
    let M = ((unixTimestamp.getMonth() + 1) >= 10 ? (unixTimestamp.getMonth() + 1) : '0' + (unixTimestamp.getMonth() + 1))
    let D = (unixTimestamp.getDate() >= 10 ? unixTimestamp.getDate() : '0' + unixTimestamp.getDate())
    let dateRes = Y + '-' + M + '-' + D ;
    return dateRes;
};

//百分比
util.toPercent = function(point){
    var str=Number(point*100).toFixed(2);
    return str;
};

export default util;



// WEBPACK FOOTER //
// ./src/utils/util.js